<div *ngIf="showBanner" class="act-banner act-cookie-banner">
    <div class="act-xl-container">
        <div class="row">
            <div class="col-9 text-left">
                {{ 'COOKIE_BANNER.TEXT' | translate }}
            </div>
            <div class="col-3 text-right">
                <button act-button color="secondary" class="pl-75 pr-75" (click)="accept()">
                    {{ 'COOKIE_BANNER.ACCEPT' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
